
export enum Suit {
  COINS = 'denari',
  CUPS = 'coppe',
  SWORDS = 'spade',
  CLUBS = 'bastoni',
}

export interface Card {
  id: string;
  value: number; // 1 to 10
  suit: Suit;
}

export interface Player {
  id: number; // 0 = human, 1+ = AI
  name: string;
  hand: Card[];
  captured: Card[];
  currentRoundScore: number;
  totalScore: number;
  scope: number;
  hasDeclaredLowHand?: boolean;
  hasDeclaredThreeAces?: boolean;
  lowHandCount?: number;
  threeAcesCount?: number;
  readyForNextRound?: boolean;
}

export type GamePhase = 'dealing' | 'playing' | 'roundEnd' | 'gameOver';

export interface PlayerRoundResult {
  cards: number;
  coins: number;
  settebello: boolean;
  dieciDenari: boolean;
  dueDenari: boolean;
  primiera: number;
  scope: number;
  lowHand: number;
  threeAces: number;
  score: number;
}

export interface GameState {
  deck: Card[];
  table: Card[];
  players: Player[];
  currentPlayerIndex: number;
  numPlayers: number;
  lastToCapture: number | null;
  lastPlayedCard: { card: Card; playerIndex: number } | null;
  phase: GamePhase;
  messages: string[];
  roundResults?: PlayerRoundResult[];
  scopaEvent?: { playerIndex: number; timestamp: number } | null;
  lowHandEvent?: { playerIndex: number; timestamp: number } | null;
  roundStartPlayer: number; // who started the current round (for alternation)
  roundEndedAt?: number;
}
